import { IAutocompleteMatch } from "@directives/_forms/autocomplete/autocomplete.component";
import { VeriDate } from "@services/veriDate.service";
import { IPlannedRouteVisit } from "@tms/_models/IPlannedRouteVisit";
import * as angular from "angular";
import "./scheduleVisitsListItem.component.scss";

interface IPredefinedOnsiteTime {
    minutes: number;
    label: string;
}

interface IPredefinedOnsiteTimeMap {
    [minutes: string]: IPredefinedOnsiteTime;
}

interface IComponentBindings {
    index?: number;
    visit?: IPlannedRouteVisit;
    calculatingRoute?: boolean;
    onChanged?: (args: { visit: IPlannedRouteVisit }) => void;
    onOnsiteTimeChanged?: (args: { visit: IPlannedRouteVisit }) => void;
    onLocationMatch: (args: { visit: IPlannedRouteVisit, match: IAutocompleteMatch }) => void;
    onLocationMatchCleared?: (args: { visit: IPlannedRouteVisit }) => void;
    onArrivalTimeChanged: (args: { visit: IPlannedRouteVisit, newTime: string }) => void;
    onVisitRemoved?: (args: { visit: IPlannedRouteVisit }) => void;
}

export class ScheduleVisitsListItemComponentController implements angular.IComponentController, IComponentBindings {

    // bindings
    index: number;
    visit: IPlannedRouteVisit;
    calculatingRoute: boolean;
    onChanged: (args: { visit: IPlannedRouteVisit }) => void;
    onOnsiteTimeChanged: (args: { visit: IPlannedRouteVisit }) => void;
    onLocationMatch: (args: { visit: IPlannedRouteVisit, match: IAutocompleteMatch }) => void;
    onLocationMatchCleared: (args: { visit: IPlannedRouteVisit }) => void;
    onArrivalTimeChanged: (args: { visit: IPlannedRouteVisit, newTime: string }) => void;
    onVisitRemoved: (args: { visit: IPlannedRouteVisit }) => void;

    onSiteTimes: IPredefinedOnsiteTimeMap = {
        [0]: { minutes: 0, label: "0 mins" },
        [5]: { minutes: 5, label: "5 mins" },
        [10]: { minutes: 10, label: "10 mins" },
        [15]: { minutes: 15, label: "15 mins" },
        [30]: { minutes: 30, label: "30 mins" },
        [45]: { minutes: 45, label: "45 mins" },
        [60]: { minutes: 60, label: "60 mins" }
    };

    // debugging
    showDebugLabels: boolean = false;

    static $inject = ["$scope", "veriDate"];

    constructor(
        private readonly $scope: angular.IScope,
        private readonly veriDate: VeriDate
    ) {
    }

    $onInit() {

    }

    $onChanges(changes: angular.IOnChangesObject) {
        const visitChange = changes["visit"];

        if (visitChange) {
            this.addAllCustomOnsiteTimes(this.visit);
        }
    }

    emitVisit(): void {
        this.$scope.$applyAsync();

        if (!this.onChanged) {
            return;
        }

        this.onChanged({ visit: this.visit });
    }

    emitOnsiteTimeChanged(): void {

        if (!this.onOnsiteTimeChanged) {
            return;
        }

        this.onOnsiteTimeChanged({ visit: this.visit });
    }

    emitLocationMatch(match: IAutocompleteMatch): void {

        if (!this.onLocationMatch) {
            return;
        }

        this.onLocationMatch({ visit: this.visit, match });
    }

    emitLocationMatchCleared(): void {

        if (!this.onLocationMatchCleared) {
            return;
        }

        this.onLocationMatchCleared({ visit: this.visit });
    }

    emitArrivalTimeChanged(newTime: string): void {
        if (!this.onArrivalTimeChanged) {
            return;
        }

        this.onArrivalTimeChanged({ visit: this.visit, newTime });
    }

    removeVisit(): void {
        if (!this.onVisitRemoved) {
            return;
        }

        this.onVisitRemoved({ visit: this.visit });
    }

    // ---

    private addAllCustomOnsiteTimes(plannedVisit: IPlannedRouteVisit): void {
        if (this.onSiteTimes[plannedVisit.onSiteTimeMins]) {
            return;
        }

        this.onSiteTimes[plannedVisit.onSiteTimeMins] = {
            minutes: plannedVisit.onSiteTimeMins,
            label: this.veriDate.formatDurationMs(plannedVisit.onSiteTimeMins * 60 * 1000)
        };
    }

}

export class ScheduleVisitsListItemComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            index: "<?",
            visit: "<?",
            calculatingRoute: "<?",
            onChanged: "&",
            onOnsiteTimeChanged: "&",
            onLocationMatch: "&",
            onLocationMatchCleared: "&",
            onArrivalTimeChanged: "&",
            onVisitRemoved: "&"
        };

        this.controller = ScheduleVisitsListItemComponentController;
        this.template = require("./scheduleVisitsListItem.component.html");
    }
}
